import { store } from 'quasar/wrappers'
import { createStore, createLogger } from 'vuex'
import createMultiTabState from 'vuex-multi-tab-state'

import auth from './auth'

/*
 * If not building with SSR mode, you can
 * directly export the Store instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Store instance.
 */

export default store(function (/* { ssrContext } */) {
  const plugins = [createMultiTabState()]
  if (process.env.DEBUGGING) {
    plugins.push(createLogger())
  }

  const Store = createStore({
    modules: {
      auth
    },

    // enable strict mode (adds overhead!)
    // for dev mode and --debug builds only
    strict: process.env.DEBUGGING,
    plugins: [...plugins] // ,

    // for dev mode and --debug builds only
    // strict: process.env.DEBUGGING
  })

  return Store
})
